import { defaultFont } from 'src/theme/core/typography';

// ----------------------------------------------------------------------

export const STORAGE_KEY = 'app-settings';

export const defaultSettings = {
  colorScheme: 'light',
  direction: 'ltr',
  contrast: 'default',
  navLayout: 'mini',
  primaryColor: 'default',
  navColor: 'apparent',
  compactLayout: false,
  fontFamily: defaultFont,
};
